// Balance (Saturn): a word with as many vowels as consonants scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { consonantCount, vowelCount } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const balance: AlignmentDef = {
  id: 'balance',
  planet: 'saturn',
  name: 'Balance',
  text: () => `Words with as many vowels as consonants score +${N.balancePercent}%.`,
  wordPercent: (c) => (vowelCount(c.word) === consonantCount(c.word) ? N.balancePercent : 0),
};
